import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const NoticeBoard = () => {
  const routes = all_routes;
  const [filter, setFilter] = useState('all');

  // Mock notices data
  const mockNotices = [
    {
      id: 1,
      title: "Winter Break Schedule Update",
      content: "Please note that winter break will begin on December 20th. Classes will resume on January 8th, 2025. All students must complete pending assignments before the break.",
      category: "Academic",
      priority: "high",
      publishDate: "2024-12-20",
      author: "Administration Office",
      isUrgent: true,
      attachments: ["winter_schedule.pdf"]
    },
    {
      id: 2,
      title: "School Annual Day Celebration",
      content: "We are excited to announce our Annual Day celebration on January 15th, 2025. Students can register for various cultural activities through their class teachers.",
      category: "Events",
      priority: "medium",
      publishDate: "2024-12-18",
      author: "Cultural Committee",
      isUrgent: false,
      attachments: []
    },
    {
      id: 3,
      title: "Examination Guidelines - Mid Term",
      content: "Mid-term examinations will commence from January 20th. Students are advised to follow the exam schedule and guidelines strictly. Hall tickets will be available from January 15th.",
      category: "Examination",
      priority: "high",
      publishDate: "2024-12-15",
      author: "Examination Department",
      isUrgent: true,
      attachments: ["exam_guidelines.pdf", "time_table.pdf"]
    },
    {
      id: 4,
      title: "Library New Books Collection",
      content: "The library has received new collection of science and literature books. Students can visit the library during break hours to explore the new additions.",
      category: "Academic",
      priority: "low",
      publishDate: "2024-12-12",
      author: "Library Department",
      isUrgent: false,
      attachments: ["book_list.pdf"]
    },
    {
      id: 5,
      title: "Sports Day Registration Open",
      content: "Registration for Sports Day 2025 is now open. Students interested in participating should submit their names to the sports teacher by December 30th.",
      category: "Sports",
      priority: "medium",
      publishDate: "2024-12-10",
      author: "Sports Department",
      isUrgent: false,
      attachments: []
    }
  ];

  const filteredNotices = mockNotices.filter(notice => {
    if (filter === 'urgent') return notice.isUrgent;
    if (filter !== 'all') return notice.category.toLowerCase() === filter.toLowerCase();
    return true;
  });

  const getCategoryColor = (category: string) => {
    switch(category.toLowerCase()) {
      case 'academic': return 'badge-soft-primary';
      case 'events': return 'badge-soft-success';
      case 'examination': return 'badge-soft-danger';
      case 'sports': return 'badge-soft-warning';
      default: return 'badge-soft-secondary';
    }
  };

  const getCategoryIcon = (category: string) => {
    switch(category.toLowerCase()) {
      case 'academic': return 'ti-book';
      case 'events': return 'ti-calendar-event';
      case 'examination': return 'ti-file-text';
      case 'sports': return 'ti-trophy';
      default: return 'ti-bell';
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between border-bottom pb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Notice Board</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.studentDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Notice Board
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div className="pe-1 mb-2">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
              >
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon me-1"
                >
                  <i className="ti ti-refresh" />
                </Link>
              </OverlayTrigger>
            </div>
            <div className="pe-1 mb-2">
              <button className="btn btn-primary">
                <i className="ti ti-bell me-2"></i>Subscribe to Notifications
              </button>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="row mt-4">
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-primary-transparent me-3">
                    <i className="ti ti-bell"></i>
                  </div>
                  <div>
                    <h4>{mockNotices.length}</h4>
                    <p className="text-muted mb-0">Total Notices</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-danger-transparent me-3">
                    <i className="ti ti-alert-triangle"></i>
                  </div>
                  <div>
                    <h4>{mockNotices.filter(n => n.isUrgent).length}</h4>
                    <p className="text-muted mb-0">Urgent</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-success-transparent me-3">
                    <i className="ti ti-calendar-event"></i>
                  </div>
                  <div>
                    <h4>{mockNotices.filter(n => n.category === 'Events').length}</h4>
                    <p className="text-muted mb-0">Events</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-warning-transparent me-3">
                    <i className="ti ti-file-text"></i>
                  </div>
                  <div>
                    <h4>{mockNotices.filter(n => n.category === 'Examination').length}</h4>
                    <p className="text-muted mb-0">Examinations</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h4 className="card-title">School Announcements</h4>
                <div className="d-flex gap-2">
                  <select 
                    className="form-select form-select-sm"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  >
                    <option value="all">All Categories</option>
                    <option value="urgent">Urgent Only</option>
                    <option value="academic">Academic</option>
                    <option value="events">Events</option>
                    <option value="examination">Examination</option>
                    <option value="sports">Sports</option>
                  </select>
                </div>
              </div>

              {/* TODO Placeholders */}
              <div className="card-body border-bottom">
                <div className="alert alert-info">
                  <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to notices API</h6>
                  <ul className="mb-0">
                    <li>Fetch notices from database</li>
                    <li>Real-time notification system</li>
                    <li>Mark notices as read/unread</li>
                    <li>Download attachments functionality</li>
                    <li>Email/SMS notification integration</li>
                  </ul>
                </div>
              </div>

              <div className="card-body">
                <div className="notices-list">
                  {filteredNotices.map((notice) => (
                    <div key={notice.id} className="notice-item border rounded p-4 mb-3">
                      <div className="d-flex align-items-start justify-content-between mb-3">
                        <div className="d-flex align-items-start flex-fill">
                          <div className={`avatar avatar-md bg-${notice.category.toLowerCase()}-transparent me-3`}>
                            <i className={`ti ${getCategoryIcon(notice.category)}`}></i>
                          </div>
                          <div className="flex-fill">
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <h5 className="mb-0">{notice.title}</h5>
                              {notice.isUrgent && (
                                <span className="badge bg-danger">Urgent</span>
                              )}
                              <span className={`badge ${getCategoryColor(notice.category)}`}>
                                {notice.category}
                              </span>
                            </div>
                            <p className="text-muted mb-2">{notice.content}</p>
                            <div className="d-flex align-items-center gap-3 text-muted">
                              <small>
                                <i className="ti ti-user me-1"></i>
                                {notice.author}
                              </small>
                              <small>
                                <i className="ti ti-calendar me-1"></i>
                                {notice.publishDate}
                              </small>
                              {notice.attachments.length > 0 && (
                                <small>
                                  <i className="ti ti-paperclip me-1"></i>
                                  {notice.attachments.length} attachment(s)
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="dropdown">
                          <button className="btn btn-outline-light btn-sm dropdown-toggle" data-bs-toggle="dropdown">
                            <i className="ti ti-dots-vertical"></i>
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <button className="dropdown-item">
                                <i className="ti ti-eye me-2"></i>Mark as Read
                              </button>
                            </li>
                            <li>
                              <button className="dropdown-item">
                                <i className="ti ti-bookmark me-2"></i>Save Notice
                              </button>
                            </li>
                            <li>
                              <button className="dropdown-item">
                                <i className="ti ti-share me-2"></i>Share
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>

                      {/* Attachments */}
                      {notice.attachments.length > 0 && (
                        <div className="attachments-section">
                          <h6 className="mb-2">Attachments:</h6>
                          <div className="d-flex gap-2 flex-wrap">
                            {notice.attachments.map((attachment, index) => (
                              <button key={index} className="btn btn-outline-primary btn-sm">
                                <i className="ti ti-download me-1"></i>
                                {attachment}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {filteredNotices.length === 0 && (
                  <div className="text-center py-5">
                    <div className="avatar avatar-xl bg-light-transparent mx-auto mb-3">
                      <i className="ti ti-bell-off fs-2"></i>
                    </div>
                    <h5>No notices found</h5>
                    <p className="text-muted">No notices match your current filter criteria.</p>
                    <button 
                      className="btn btn-primary"
                      onClick={() => setFilter('all')}
                    >
                      Show All Notices
                    </button>
                  </div>
                )}

                {/* Pagination */}
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <p className="text-muted mb-0">Showing {filteredNotices.length} of {mockNotices.length} notices</p>
                  <nav>
                    <ul className="pagination pagination-sm mb-0">
                      <li className="page-item disabled">
                        <button className="page-link">Previous</button>
                      </li>
                      <li className="page-item active">
                        <button className="page-link">1</button>
                      </li>
                      <li className="page-item">
                        <button className="page-link">2</button>
                      </li>
                      <li className="page-item">
                        <button className="page-link">Next</button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticeBoard;
